import React from 'react';
import { Typography } from 'antd';

const { Paragraph, Text, Title } = Typography;

/** One-line goal per tab — shown as a heading, not a wall of text. */
export const TAB_GOALS = {
  general: 'Name this visit type, optional check-in notification copy, and when facilities can offer it.',
  entitlement: 'Decide if every member can use it, or only those with a specific plan benefit.',
  'facility-types': 'Filter by kind of site — dental clinics, hospitals, pharmacies, etc.',
  facilities: 'Optionally narrow further to specific named hospitals or clinics.',
  tariffs: 'Pick standard price lists and the service group for each (e.g. Lab, Drugs).',
  categories: 'When price lists are linked, service groups come from the Prices step — review the summary here.',
  items: 'Optionally allow or block specific procedures on top of the price list.',
  workflow: 'Choose when facilities must attach documents — one file for the whole encounter, or per line when needed.',
  preview: 'See what a facility would actually get before you turn this on.',
};

export function TabGoal({ tabKey }) {
  const goal = TAB_GOALS[tabKey];
  if (!goal) return null;
  return (
    <div style={{ marginBottom: 20 }}>
      <Title level={5} style={{ margin: 0, fontWeight: 600 }}>{goal}</Title>
    </div>
  );
}

export function FieldHint({ children, style }) {
  if (!children) return null;
  return (
    <Paragraph type="secondary" style={{ fontSize: 12, marginTop: 4, marginBottom: 0, ...style }}>
      {children}
    </Paragraph>
  );
}

export const ENTITLEMENT_HELP = {
  generic: 'Good for general outpatient visits where any enrolled member is allowed.',
  category_required: 'Good for Dental, Optical, etc. — member must have that benefit on their plan.',
};

export const EVIDENCE_MODE_HELP = {
  not_needed: 'Facilities can submit PA without attaching a file.',
  optional: 'They may attach a referral or report, but it is not enforced.',
  required: 'They must upload before the PA can be finalized.',
};

/** PA header evidence — whole-encounter upload step. */
export const EVIDENCE_HEADER_LABEL = 'PA header documents';
export const EVIDENCE_HEADER_HINT =
  'One file for the whole encounter (e.g. lab results, referral letter). When set to Required, facilities upload here and finalize — not per line at checkout.';

/** Category / per-line evidence — only when each line needs its own proof. */
export const EVIDENCE_LINE_LABEL = 'Category / item documents';
export const EVIDENCE_LINE_HINT =
  'Only use when each line needs its own proof. For annual medicals, lab bundles, and similar programs, leave category and item rules as Not needed and require the header document instead.';

export const EVIDENCE_BUNDLE_PRESET = {
  title: 'Recommended for annual medicals & lab bundles',
  description:
    'Set PA header documents to Required. Leave category and item document rules as Not needed so facilities upload one encounter file instead of per-line uploads.',
};

export const CLAIMS_STATUS_HELP = {
  0: 'Claims wait for the Claims Officer first.',
  1: 'Claims wait for Head of Medical first.',
  2: 'Claims wait for CFO first.',
};

export const CHECKIN_MESSAGE_PLACEHOLDERS = [
  '{enrollee_first_name}',
  '{enrollee_name}',
  '{facility_name}',
  '{checkin_type}',
  '{encounter_date}',
];
